import { createAction, handleActions } from 'redux-actions';

import Agent from '../api/Agent';

export const setRoles = createAction('RESOURCES/SET_ROLES');
export const setStates = createAction('RESOURCES/SET_STATES');

const INITIAL_STATE = {
  roles: [],
  states: [],
};

export default handleActions(
  {
    'RESOURCES/SET_ROLES': (state, action) => ({ ...state, roles: action.payload }),
    'RESOURCES/SET_STATES': (state, action) => ({ ...state, states: action.payload }),
  },
  INITIAL_STATE,
);

export const getRoles = () => (dispatch) => {
  Agent.roleOptions().then((response) => {
    if (response.ok) {
      const roles = response.data.map((role) => ({
        label: role.name,
        text: role.name,
        value: +role.id,
      }));

      dispatch(setRoles(roles));
    }
  });
};

export const getStates = () => (dispatch) => {
  Agent.getStates().then((response) => {
    if (response.ok) {
      const states = response.data.map((state) => ({
        label: state.state,
        text: state.state_code,
        value: +state.id,
      }));

      dispatch(setStates(states));
    }
  });
};
